<template>
  <div id="app" v-cloak :style="appStyle">
    <div class="top-nav" v-if="isShowNav">
      <van-icon
        :style="{
          visibility: hideBack ? 'hidden' : 'visible',
        }"
        name="arrow-left"
        :size="20"
        @click="backRouter"
      />
      <div class="top-nav-title">{{ topNavName || '' }}</div>
      <van-icon
        name="wap-home-o"
        :size="20"
        @click="homeRouter"
        v-if="!isCustomerPage"
        class="top-nav-right"
      />
    </div>
    <div
      :class="[isShowNav ? 'have-nav' : 'no-have-nav', 'nav-style']"
      id="app-container"
    >
      <keep-alive :include="cachedComponents">
        <router-view
          v-if="
            !isRouterAlive && isLiveInfoOk && isUserInfoOk && agentVisibleComp
          "
        />
      </keep-alive>
    </div>
    <FontSizeSetting></FontSizeSetting>
    <HealthScene></HealthScene>
  </div>
</template>

<script>
import config from '@/config'
import commonAjax from '@/utils/http/modules/common.request.js'
import changhongAjax from '@/utils/http/modules/changhong/changhong.request'
import {
  getUserAuth,
  getAgentGray,
} from '@/utils/http/modules/agent/auth.request'
import {
  setLocal,
  getLocal,
  removeLocal,
  getCookie,
  isWeChat,
  isPcWeChat,
  fixDate,
  getParams,
  isWx,
  getEnv,
  deleteCookie,
  usePcPage,
  setCookie,
  isMiniApp,
  delMyCookie,
  getHost,
} from '@/utils/utils.js'
import muTypes from '@/store/mutation-types.js'
import { ROLEENUM } from '@/enum'
import { whitePathList } from '@/pages/agent/js/enum'
import { mapMutations, mapGetters, mapActions } from 'vuex'
import InitWXSDK from '@/utils/wxconfig'
// import { CUSTOM_LIVE } from '@/utils/customLive'
import { HandleSensors } from '@/plugin/SensorsData'
import { getZbAuthUrl } from '@/utils/http/modules/camp/camp.request'
import customConfigMixin from '@/mixins/customConfigMixin'
import $agent_api, {
  BindExternalUserId,
} from '@/utils/http/modules/agent/agent.request'
import { useTrainConfig } from '@/utils/useTrainConfig'
import ConfigModel from '@store/models/config/config.model'
import { fromVzanHostPath } from '@/pages/commission/aboutPassword.js'
import { isVzanApp } from './utils/utils'
import { lgyslide } from '@/utils/jquery.lgyslide.js'
import { authSenceMap } from '@/pages/agent/directive/VAuth'

import FontSizeSetting from '@/components/FontSizeSetting'
import HealthScene from '@/components/HealthScene.vue'
export default {
  name: 'App',
  components: {
    FontSizeSetting,
    HealthScene,
  },
  mixins: [customConfigMixin],
  provide() {
    return {
      handleLogin: this.handleLogin,
      reload: this.reload,
    }
  },
  data() {
    return {
      isRouterAlive: true,
      isLiveInfoOk: false,
      isUserInfoOk: false,
      agentVisible: false,
      entryType: '',
      // 顶部导航不显示的页面路径白名单
      navWhiteList: ['CwxPhraseList', 'CwxPhraseForm', 'CwxPhraseGroupForm'],
    }
  },
  computed: {
    ...mapGetters([
      'cachedComponents',
      'guokeCustomization',
      'getAuthDataAndAgentSetting',
      'getAgentAuthList',
      'getIsAgentGray',
      'getIsAgent',
    ]),
    weComFriend({ $route }) {
      return $route.query.wcf || $route.query.weComFriend
    },
    isShowNav() {
      // 检查当前路由名称是否在路由白名单中
      const isInRouteWhiteList =
        this.$route &&
        this.$route.name &&
        this.navWhiteList.includes(this.$route.name)
      return (
        isWx('work') &&
        !(location.pathname.indexOf('authPage') > -1) &&
        !isInRouteWhiteList
      )
    },
    hideBack({ $route }) {
      return ['groupDetail'].includes($route.name)
    },
    isCustomerPage() {
      // 使用正则表达式匹配entryType字段的值
      const regex = /[?&]entryType=([^&#]*)/
      // 使用exec方法从URL中提取entryType字段的值
      const match = regex.exec(window.location.href)
      // 如果匹配成功，则返回entryType的值，否则返回null
      let hasEntryType =
        match && decodeURIComponent(match[1].replace(/\+/g, ' '))
      if (hasEntryType) {
        return hasEntryType === 'customerService'
      } else {
        return false
      }
    },
    agentVisibleComp() {
      if (window.location.pathname.indexOf('/agent/') > -1) {
        return this.agentVisible
      } else {
        return true
      }
    },
    topNavName() {
      return this.$route.meta.topNavName
    },
    appStyle() {
      return {
        'max-width': usePcPage ? '4.76rem' : '3.75rem',
      }
    },
    isAdmin() {
      return (
        getEnv() == 'prod' ? ['CREATOR', 'ADMIN'] : ['CREATOR', 'ADMIN']
      ).some(
        v =>
          window.userInfo &&
          window.userInfo.roles &&
          window.userInfo.roles.includes(v)
      )
    },
    isCustomerService() {
      return this.$route.query.entryType === 'customerService'
    },
    zbId({ $route }) {
      return (
        this.$route.query.zbid || this.$route.query.zbId || window.zbvd.zbid
      )
    },
    isStore({ $route }) {
      return this.$route.meta[ConfigModel['ROUTE_META_KEY']]
    },
  },
  watch: {
    // 防止跳转到新的直播间的时候没有更新直播间信息
    '$route.query.zbid': {
      handler(newValue) {
        if (
          !!newValue &&
          newValue != '0' &&
          newValue !== String(window.zbvd.zbid) &&
          !this.isStore
        ) {
          window.zbvd.zbid = newValue
          this.setAgentAuth()
          this.getLiveInfo()
        } else if (!this.$store.state.isFetchAgentAuthList) {
          console.log('here???')
          // this.setAgentAuth()
        }
      },
      deep: true,
    },
  },
  methods: {
    ...mapMutations({
      setAuthDataAndAgentSetting: muTypes.setAuthDataAndAgentSetting,
      setAgentAuthList: muTypes.setAgentAuthList,
      setAgentGray: muTypes.setAgentGray,
      isForBiddenLive: muTypes.isForBiddenLive,
    }),
    ...mapActions(['getSelfVerifyConfigAction']),
    redirectOriginHost(zbvd, domainKey) {
      if (
        !zbvd.domainUrl &&
        zbvd.wapDomainUrl &&
        zbvd.wapDomainUrl != window.location.origin &&
        !isWx('work') &&
        !isMiniApp() &&
        getEnv() == 'prod' &&
        !sessionStorage.getItem(domainKey)
      ) {
        sessionStorage.setItem(domainKey, 1)
        const path = `${zbvd.wapDomainUrl}${window.location.pathname}${window.location.search}`
        window.location.replace(path)
        return
      }
    },
    // 企微环境设置独立域名cookie
    handleSetDomainCookie() {
      const setDomainCookieKey = `setDomainCookie_${zbvd.zbid}`
      // 独立域名非.vzan.com主域名则创建iframe写入独立域名cookie信息
      if (
        isWx('work') &&
        !/.vzan.com/g.test(window.zbvd.domainUrl) &&
        !getCookie(setDomainCookieKey) &&
        /.vzan.com/g.test(location.host)
      ) {
        setCookie(setDomainCookieKey, 1)
        window.location.replace(
          `${getHost()}/live/page/setUserCookie?zbvz_userid=${getCookie(
            config.COOKIE_KEY
          )}&backUrl=${encodeURIComponent(location.href)}`
        )
      }
    },
    handleForceAuth(res) {
      const pathname = location.pathname.replace(config.routerPath, '')
      let { zbId } = getParams()
      let zbid = window.zbvd.zbid
      if (
        zbId &&
        !Number.isNaN(Number(zbId)) &&
        Number(zbId) > 0 &&
        zbid == 75999
      ) {
        // zbid为75999时 若链接参数带有zbId 优先用zbId去授权
        zbid = zbId
      }
      if (
        config.forceAuthPath.includes(pathname) &&
        !getCookie(config.forceAuthKey)
      ) {
        setCookie(config.forceAuthKey, 1)
        setTimeout(() => {
          window.location.href = `/live/ThirdWapLogin-${zbid}?backurl=${
            res.dataObj
          }&zbid=${zbid}&doauth=1${
            this.weComFriend
              ? '&wcf=' + encodeURIComponent(this.weComFriend)
              : ''
          }`
        }, 500)
      } else {
        window.location.href = `/live/ThirdWapLogin?backurl=${
          res.dataObj
        }&zbid=${zbid}${
          this.weComFriend ? '&wcf=' + encodeURIComponent(this.weComFriend) : ''
        }`
      }
    },
    backRouter() {
      if (
        this.$route.name === 'agentIndex' &&
        this.$route.query?.activeNum === '1'
      ) {
        // 直播推广 返回到工作台
        window.location.href = `/live/m/agent/index?zbid=${window.zbvd.zbid}&activeNum=0`
      } else {
        this.$router.back()
      }
    },
    homeRouter() {
      this.$router.replace({
        name: 'workbench',
        query: { ...this.$route.query },
      })
    },
    gotoMineLogin() {
      window.location.href = '/live/mine?zbid=' + window.zbvd.zbid
    },
    async getWeChatSignature() {
      const {
        dataObj: { appid, noncestr, signature, timestamp },
      } = await commonAjax.getWeChatSignature({
        zbid: window.zbvd.zbid,
      })
      InitWXSDK({
        config: {
          appid,
          timestamp,
          noncestr,
          signature,
        },
      }).then(() => {})
    },
    async get_user_info() {
      try {
        this.isUserInfoOk = false
        const user_info_res = await commonAjax.get_user_info({
          liveId: window.zbvd.zbid,
        })
        if (user_info_res && user_info_res.dataObj) {
          // 获取当前企微用户所在的企业id
          window.corpId = user_info_res.dataObj.wkCropId
          window.weComFriend = user_info_res.dataObj.wkUserId
          const isClear = sessionStorage.getItem('clurCookie') !== null
          if (user_info_res.dataObj.clurCookie && !isClear) {
            sessionStorage.setItem('clurCookie', '1')
            delMyCookie()
            location.reload()
            return
          }
          // 用户状态是禁用 跳转到错误提示页
          if (!user_info_res.dataObj.state) {
            window.location.href = '/livecontent/401.html?bk=4000'
          }
          /**
           * channelId:频道id（只有这个有值才能判定你是频道管理员，才能得到该频道下的角色）
           * topicId:话题id（只有这个有值才能判定你是直播间创建者，才能重结果得到该话题下的角色）
           * **/
          const role_res = await commonAjax.getRole({
            userId: user_info_res.dataObj.id,
            liveId: window.zbvd.zbid,
            topicId: window.zbvd.tpid || undefined,
            channelId: window.zbvd.cid || undefined,
            isCheckExtenRole: true,
          })
          console.log('11111', role_res)
          if (role_res.dataObj && role_res.dataObj.length) {
            user_info_res.dataObj.roles = role_res.dataObj.map(v => ROLEENUM[v])
            user_info_res.dataObj.roleIds = role_res.dataObj
          } else {
            user_info_res.dataObj.roles = [ROLEENUM[0]]
            user_info_res.dataObj.roleIds = []
          }
          // 如果用户信息既没有头像也没有昵称，则需要强制授权（会员注册页）
          const pathname = location.pathname.replace(config.routerPath, '')
          if (
            !user_info_res.dataObj.headimgurl &&
            !user_info_res.dataObj.nickname &&
            (isWeChat() || isPcWeChat()) &&
            config.forceAuthPath.includes(pathname)
          ) {
            try {
              const url = encodeURIComponent(window.location.href)
              const res = await commonAjax.getEncryptUrlInfo(url)
              this.handleForceAuth(res)
            } catch (e) {
              console.log(e)
            }
          }
          this.updateUserInfo(
            Object.assign(window.userInfo, user_info_res.dataObj)
          )
          // if (this.isAllowMember) {
          //   this.$store.dispatch('get_member')
          // }
        } else {
          this.$dialog
            .alert({
              title: '提示',
              message: '您尚未登录!',
              confirmButtonText: '去登录',
            })
            .then(() => {
              this.gotoMineLogin()
            })
        }
      } catch (err) {
        console.log(err)
      } finally {
        this.isUserInfoOk = true
      }
    },
    reload() {
      this.isRouterAlive = true
      this.$nextTick(() => {
        this.isRouterAlive = false
      })
    },
    // 跳转到错误页方法
    async go_error(isAgent) {
      let query = {}
      if (isAgent) {
        query = {
          3: '你不是代理员，请联系管理员',
        }
      } else {
        query = {
          1: '您已被禁用',
          2: '请联系管理员',
        }
      }
      if (isAgent && !this.isAdmin) {
        console.log('代理申请跳转')
        if (this.isShowNav) {
          // 企微环境继续跳转申请页
          await this.$router.replace({
            name: 'agentApply',
            query: { ...this.$route.query, agentLevel: 1, superiorId: '' },
          })
        } else {
          if (window.location.pathname.indexOf('/agent/apply') > -1) {
            // 非申请页面在审核中则跳转到无权限页面
            await this.$router.replace(
              `/agent/result?zbid=${window.zbvd.zbid}&customerId=${window.userInfo.id}`
            )
          } else {
            await this.$router.replace({
              name: 'agentError',
              query,
            })
          }
        }
        // window.location.replace(
        //   `/live/m/agent/apply?zbid=${window.zbvd.zbid}&agentLevel=1&superiorId=`
        // )
        return
      }
      await this.$router.replace({
        name: 'agentError',
        query,
      })
    },
    extractEntryType(url) {
      // 使用正则表达式匹配entryType字段的值
      const regex = /[?&]entryType=([^&#]*)/

      // 使用exec方法从URL中提取entryType字段的值
      const match = regex.exec(url)

      // 如果匹配成功，则返回entryType的值，否则返回null
      return match && decodeURIComponent(match[1].replace(/\+/g, ' '))
    },
    // 设置代理中心权限
    async setAgentAuth() {
      const { isCustomerCode } = getParams()
      let entryType = this.extractEntryType(window.location.href)
      let isCustomerServiceTemp = entryType === 'customerService'
      // 这个地方先去拿获取到的authData，但由于存在从白名单(申请页)返回到工作台的情况，此时拿不到代理信息，故用 getIsAgent（该值在layout中会赋值）
      const isAgent =
        (this.authData && this.authData.isAgent) || this.getIsAgent
      this.$store.commit(muTypes.setIsAgent, isAgent || false)
      const isRole = this.authData && this.authData.isRole
      const result = await getAgentGray({
        tenant_id: window.zbvd.zbid,
      })
      // 国科
      if (this.guokeCustomization) {
        return
      }
      // 企微客服
      if (isCustomerServiceTemp || (isCustomerCode == 1 && isRole)) {
        return
      }
      if (
        window.location.pathname.indexOf('/agent/') == -1 ||
        (this.isAdmin && !isAgent) ||
        whitePathList.includes(this.$route.path)
      ) {
        return
      }
      if (result.code === 0 && result.data) {
        this.setAgentGray(true)
        await this.getAgentUserAuth()
      }
    },

    // 获取代理员信息(代理中心相关逻辑)
    // 判断url 是否包含字符串数组里面的元素
    checkUrlForStrings(url, stringsToCheck) {
      return stringsToCheck.some(str => url.includes(str))
    },

    /** 国科直播间 获取团队负责人身份信息 */
    async checkIdentify() {
      if (this.guokeCustomization) {
        const zbId = this.$route.query.zbid || window.zbvd.zbid
        const data = await this.$store.dispatch('updateAgentTeamConfig', zbId)
        if (data.isLeader && data.roleType == 0) {
          this.$router.replace({
            name: 'agentIdentitySelect',
            query: {
              zbid: zbId,
            },
          })
          return
        }
      }
    },

    // ！！非代理不可调用  获取代理员信息
    async getAgentAuthFuc() {
      const { isCustomerCode } = getParams()
      let entryType = this.extractEntryType(window.location.href)
      let isCustomerServiceTemp = entryType === 'customerService'
      try {
        const res = await $agent_api.getAgentAuth({ zbId: window.zbvd.zbid })
        const settingRes = await $agent_api.getAgentSetting({
          zbId: window.zbvd.zbid,
          tpId: this.$route.query.tpid,
        })
        if (res.code == 0) {
          const agentSetting = {
            ...(settingRes.dataObj || {}),
            businessModel: settingRes.dataObj?.businessModel || 0,
          }
          this.authData = {
            ...res.dataObj,
            agentSetting,
            agentRecharge: settingRes.dataObj
              ? settingRes.dataObj.agentRecharge && res.dataObj.agentIsGeneral
              : false,
          }
          this.setAuthDataAndAgentSetting(this.authData)
          console.log('this.authData:', this.authData)
          await this.setAgentAuth()
          const customerWhitePage = [
            'customerDetail',
            'storeRecord',
            'customerError',
          ]
          if (!this.authData.isRole && !isCustomerServiceTemp) {
            await this.checkIdentify()
          }
          if (
            !this.authData.agentSetting.isOpenHealth ||
            (!this.authData.agentSetting.showStore &&
              isCustomerServiceTemp &&
              window.location.href.includes('storeRecord')) // 门店管理的客服链接
          ) {
            await this.$router.replace({
              name: 'jianKangWithoutAuth',
              query: { ...this.$route.query },
            })
            return
          } else if (
            this.authData.isRole &&
            isCustomerCode != 1 &&
            !this.checkUrlForStrings(window.location.href, customerWhitePage)
          ) {
            console.log(
              'customerWhitePage',
              !this.checkUrlForStrings(window.location.href, customerWhitePage)
            )
            await this.$router.replace({
              name: 'customerError',
              query: {
                ...this.$route.query,
                status: 2,
                entryType: 'customerService',
              },
            })
            return
          } else if (
            isCustomerServiceTemp &&
            this.authData.isAgent &&
            this.checkUrlForStrings(window.location.href, customerWhitePage)
          ) {
            await this.$router.replace({
              name: 'customerError',
              query: {
                ...this.$route.query,
                status: 3,
                entryType: 'customerService',
              },
            })
            return
          } else if (
            !this.authData.isAgent &&
            !this.isAdmin &&
            !this.authData.isRole &&
            !isCustomerServiceTemp
          ) {
            // 社群接龙这两个页面不拦截，对普通用户开放
            let socialCommunityFissionPage = [
              'SocialCommunityFissionProduct',
              'ScfProductDetails',
            ]
            const isSocialCommunityFissionPage =
              socialCommunityFissionPage.includes(this.$route.name)
            if (!isSocialCommunityFissionPage) {
              console.log('进入App页跳转审核页')
              await this.go_error(!this.authData.isAgent)
            }
            return
          } else if (
            this.authData.isAgent &&
            this.authData.level == 1 &&
            window.location.pathname.indexOf('/agent/myTeam') > -1 &&
            !this.authData.isRole &&
            !isCustomerServiceTemp
          ) {
            await this.$router.replace({
              name: 'agentIndex',
              query: {
                zbid: window.zbvd.zbid,
              },
            })
            return
          }
        }
      } catch (error) {
        console.log(error)
      } finally {
        this.agentVisible = true
      }
    },
    setLiveInfo(info) {
      const { merchantMiniConfig } = info
      this.setMerchantMiniConfig(merchantMiniConfig)
      // try {
      //   const config_res = await commonAjax.get_config({
      //     zbId: window.zbvd.zbid
      //   })
      //   // customZb 定制直播间
      //   res.dataObj.customLive = config_res.dataObj.customZb
      //     ? CUSTOM_LIVE[config_res.dataObj.customZb]
      //     : window.zbvd.customLive
      // } catch (error) {
      //   console.log('get_config error', error)
      // }

      this.updateZbvd(Object.assign(window.zbvd, info))
      const domainKey = `redirectOriginHost_${window.zbvd.zbid}`
      this.redirectOriginHost(info, domainKey)
      if (window.zbvd.zbid != 75999) {
        this.getCustomLive() // from customConfigMixin
      }
      this.isLiveInfoOk = true
    },
    async getLiveInfo() {
      try {
        const { zbid } = getParams()
        const res = await commonAjax.getSiteInfoById({
          zbid: Number(zbid) > 0 ? zbid : window.zbvd.zbid,
          isMinePage: 1,
        })
        if (res.dataObj) {
          this.setLiveInfo(res.dataObj)
        } else {
          // 封禁直播间的情况下 可以进入的一些页面
          const whitePathList = [
            '/mine/index',
            '/live/m/order/myorder',
            '/live/m/verify/verifyResult',
            '/live/m/mine/accountInfo',
            '/live/m/myCouponList',
            '/live/m/memberPoints/index',
            '/live/m/income',
            '/live/incomerecord',
            '/live/incomeanalyze',
            '/live/incomedistribution',
            '/live/myredbag',
            '/live/m/mine/awardList',
            '/live/m/mine/userVerify',
          ]
          const whitePath = whitePathList.find(item => {
            return window.location.pathname.indexOf(item) > -1
          })
          // 判断是否为代理中心
          const pathname = window.location.pathname.indexOf('/agent/') != -1
          const message = pathname ? res.msg + `\n如果代理员需要为用户核销，可以通过微信扫一扫核销` : res.msg
          if (res.code === 10045 && whitePath) {
            const result = await commonAjax.getSiteInfoByIdExt({
              zbid: Number(zbid) > 0 ? zbid : window.zbvd.zbid,
            })
            if (result.dataObj) {
              this.setLiveInfo(result.dataObj)
              this.isForBiddenLive(true)
            }
          } else {
            this.$dialog.alert({
              title: '提示',
              message: message,
              confirmButtonText: '知道了',
              confirmButtonColor: '#0084ff',
            })
          }
        }
      } catch (error) {
        this.$dialog.alert({
          title: '提示',
          message: error,
          confirmButtonText: '知道了',
          confirmButtonColor: '#0084ff',
        })
      }
    },
    // 获取token
    async getLiveToken() {
      try {
        const COOKIE = getCookie(config.COOKIE_KEY)
        if (COOKIE) {
          const {
            dataObj: { token, tokenExpires, encUserid },
          } = await commonAjax.getLiveToken({
            encryptUserId: COOKIE,
          })
          this.updateUserInfo(Object.assign(window.userInfo, { encUserid }))
          setLocal(
            `${config.TOKEN_KEY}`,
            JSON.stringify({ token, tokenExpires, vzUserId: COOKIE, encUserid })
          )
          await this.getLiveInfo()
          await this.getLiveCustomInfo()
        }
        this.isRouterAlive = false
      } catch (error) {
        console.log(error)
        if (this.env === 'dev' || this.env === 'test') {
          this.$toast('本地开发请手动添加登录参数')
        }
      }
    },
    async checkChanghong() {
      try {
        const { data } = await changhongAjax.postCheckChanghong()
        // true: 需要重新授权 false: 不需要重新授权
        if (data) {
          document.cookie = `${config.COOKIE_KEY}=; expires=-1`
          removeLocal(config.TOKEN_KEY)
          this.thirdWapLogin()
        }
      } catch (e) {
        console.log(e)
      }
    },
    // 带上zbid 第三方授权登录
    async thirdWapLogin() {
      try {
        const url = encodeURIComponent(window.location.href)
        const res = await commonAjax.getEncryptUrlInfo(url)
        if (this.env === 'dev' || this.env === 'test') {
          this.$toast('本地开发请手动添加登录参数')
        } else {
          window.location.href =
            '/live/ThirdWapLogin?backurl=' +
            res.dataObj +
            '&zbid=' +
            window.zbvd.zbid +
            `${
              this.weComFriend
                ? '&wcf=' + encodeURIComponent(this.weComFriend)
                : ''
            }`
        }
      } catch (error) {
        this.$toast('获取授权失败。')
        this.gotoMineLogin()
      }
    },
    async authorization() {
      const isWxwork = /wxwork/i.test(navigator.userAgent)
      const date = new Date()
      date.setTime(date.getTime() + 7 * 24 * 60 * 60 * 1000)
      if (!getCookie(config.COOKIE_KEY)) {
        if (isWeChat() || isPcWeChat() || isVzanApp()) {
          try {
            const url = encodeURIComponent(window.location.href)
            const res = await commonAjax.getEncryptUrlInfo(url)
            if (isWxwork) {
              // 企业微信跳到登录页
              localStorage.clear()
              sessionStorage.clear()
              console.log(location.href)
              // window.location.href = `/live/login-${zbvd.zbid}?backurl=${res.dataObj}&type=thirdwaplogin`
              // window.location.href = `/live/ThirdWapLogin?backurl=${res.dataObj}&zbid=${window.zbvd.zbid}&wkauth=1`
              if (
                config.AgentWorkWeiXinWhitePath.filter(
                  item => location.href.indexOf(item) > -1
                ).length
              ) {
                window.location.href = `/live/ThirdWapLogin?backurl=${
                  res.dataObj
                }&zbid=${window.zbvd.zbid}&wkauth=1${
                  this.weComFriend
                    ? '&wcf=' + encodeURIComponent(this.weComFriend)
                    : ''
                }`
              } else {
                window.location.href = `/live/login-${zbvd.zbid}?backurl=${
                  res.dataObj
                }&type=thirdwaplogin${
                  this.weComFriend
                    ? '&wcf=' + encodeURIComponent(this.weComFriend)
                    : ''
                }`
              }
              return
            }
            if (this.env === 'dev' || this.env === 'test') {
              this.$toast('本地开发请手动添加登录参数')
            } else {
              this.handleForceAuth(res)
            }
          } catch (error) {
            this.$toast('获取授权失败。')
            this.getLoginUrl()
          }
        } else {
          this.getLoginUrl()
          this.isRouterAlive = false
        }
      } else {
        await this.checkTokenGetLiveInfo()
        if (
          location.pathname.indexOf('agent/authPage') > -1 &&
          this.weComFriend
        ) {
          console.log('执行了BindExternalUserId')
          try {
            const bindData = await BindExternalUserId({
              zbId: this.zbId,
              extuid: this.weComFriend,
              crpId: window.corpId,
            })
            if (bindData.code == '1001') {
              // 强制授权
              try {
                const url = encodeURIComponent(window.location.href)
                const res = await commonAjax.getEncryptUrlInfo(url)
                window.location.href = `/live/ThirdWapLogin-${
                  window.zbvd.zbid
                }?backurl=${res.dataObj}&zbid=${window.zbvd.zbid}&doauth=1${
                  this.weComFriend
                    ? '&wcf=' + encodeURIComponent(this.weComFriend)
                    : ''
                }`
              } catch (e) {
                console.log(e)
              }
            }
          } catch (e) {
            console.log(e)
          }
        }
      }
    },
    async checkTokenGetLiveInfo() {
      // 判断当前token是否存在
      const tokenObj = getLocal(`${config.TOKEN_KEY}`)
      if (
        tokenObj !== null &&
        Object.prototype.hasOwnProperty.call(tokenObj, 'tokenExpires')
      ) {
        // 请求接口同步服务器时间 token存储时间与当前时间比较
        const tokenTime = +fixDate(tokenObj.tokenExpires)
        let currentTime = +new Date()
        try {
          await this.$store.dispatch('upDateGlobalTime')
          currentTime = this.$store.getters.serverNow
        } catch (e) {
          currentTime = +new Date()
        }
        // 如果存储token的时间大于当前时间,token生效; 反之判定存储的token过期,需要重新登录
        if (
          tokenTime > currentTime &&
          tokenObj.vzUserId == getCookie('zbvz_userid')
        ) {
          console.log('tokenObj.vzUserId', tokenObj.vzUserId)
          this.updateUserInfo(
            Object.assign(window.userInfo, { encUserid: tokenObj.encUserid })
          )
          this.isRouterAlive = false
          await this.getLiveInfo()
          await this.getLiveCustomInfo()
        } else {
          this.getLiveToken()
        }
      } else {
        this.getLiveToken()
      }
    },
    async getLiveCustomInfo() {
      // 长虹直播间
      if (window.zbvd.customLive === 'CHANG_HONG') {
        await this.checkChanghong()
      }
      await this.get_user_info()
      const whitePathList = [
        '/agent/period',
        '/agent/warmPrompt',
        '/agent/errInfo',
        '/agent/error',
        '/agent/result',
        '/agent/apply',
        '/agent/newInviteCard',
        '/agent/sumVerify',
        '/agent/batchVerify',
        '/agent/verifyRecord',
        '/agent/activateAgent',
        '/agent/aliGuidePage',
        '/agent/AuthLogin',
        '/agent/authPage',
        '/agent/identity-select',
        '/agent/openAccount',
        '/agent/openAccountStatus',
        '/agent/periodInviteCard',
        '/agent/agentBind',
      ]
      const whitePath = whitePathList.find(item => {
        return window.location.pathname.indexOf(item) > -1
      })
      // 注意此处不要擅自新增逻辑、 非代理不要执行此处，会跳转到 403 页面
      if (
        (window.location.pathname.indexOf('/agent/') > -1 ||
          window.location.pathname.indexOf('/m/store/') > -1) &&
        !whitePath
      ) {
        this.getAgentAuthFuc()
      } else {
        this.agentVisible = true
      }
    },
    // H5端获取用户自主核销配置
    getSelfVerifyConfig() {
      this.getSelfVerifyConfigAction()
    },
    // 获取代理中心的权限
    async getAgentUserAuth() {
      const entryType = this.extractEntryType(window.location.href)
      try {
        const result = await getUserAuth({})
        console.log('getUserAuth.result ==> ', result)
        if (result.code === 0) {
          if (result.data.length) {
            let agentSetting = this.authData?.agentSetting
            if (!agentSetting) {
              try {
                const settingRes = await $agent_api.getAgentSetting({
                  zbId: window.zbvd.zbid,
                  tpId: this.$route.query.tpid,
                })
                agentSetting = settingRes.dataObj || {}
              } catch (err) {
                console.log(err)
              }
            }
            const businessModel = agentSetting?.businessModel || 0
            let list = authSenceMap(result.data, businessModel)
            this.setAgentAuthList(list || [])
          } else {
            let socialCommunityFissionPage = [
              'SocialCommunityFissionProduct',
              'ScfProductDetails',
            ]
            const isSocialCommunityFissionPage =
              socialCommunityFissionPage.includes(this.$route.name)
            if (
              entryType !== 'customerService' &&
              !isSocialCommunityFissionPage
            ) {
              await this.$router.push({
                name: '403',
                query: { msg: '您暂无权限访问代理中心', ...this.$route.query },
              })
              return
            }
          }
        }
      } catch (err) {
        this.setAgentGray(false)
      }
    },

    // 获取登录地址
    async getLoginUrl() {
      const pathname = location.pathname.replace(config.routerPath, '')
      const routerLoginList = [
        '/course/detail',
        '/camp/detail',
        '/audio/detail',
        '/video/detail',
        '/image-text/detail',
        '/special/detail',
        '/mine/index',
        '/cardMember/detail',
        '/agent/index',
        '/agent/period',
        '/agent/openAccount',
        '/agent/openAccountStatus',
      ]
      if (window.zbvd.zbid && routerLoginList.includes(pathname)) {
        let params = {
          zbId: window.zbvd.zbid,
          redirecturi: location.href,
        }
        if (pathname === '/mine/index') {
          params.redirecturi =
            location.origin + '/live/mine-' + window.zbvd.zbid || 0
        }
        const { data } = await getZbAuthUrl(params)
        if (data) {
          window.location.replace(data)
        }
      } else {
        localStorage.setItem(
          'wx-prelogin-page',
          encodeURIComponent(window.location.href)
        )
        window.location.href = '/live/mine?zbid=' + (window.zbvd.zbid || 75999)
      }
    },
    // // 判断是否是灰度直播间
    // async checkGray() {
    //   try {
    //     let res = await commonAjax.checkGrayLive({
    //       zbid: window.zbvd.zbid,
    //     })
    //     localStorage.setItem('isGrayLive', res.dataObj)
    //   } catch (error) {
    //     localStorage.setItem('isGrayLive', false)
    //   }
    // },
    ...mapMutations({
      updateZbvd: muTypes.zbvd,
      updateUserInfo: muTypes.userInfo,
      setMerchantMiniConfig: muTypes.setMerchantMiniConfig,
      setSelfVerifyConfig: muTypes.setSelfVerifyConfig,
    }),
    async handleLogin() {
      await this.authorization()
      await useTrainConfig()
      // 企微聊天外部联系人跳转到对应页面
      let chatOpenUrl = getCookie(`chat_openUrl`)
      if (chatOpenUrl) {
        deleteCookie('chat_openUrl')
        setTimeout(() => {
          location.href = chatOpenUrl
        }, 500)
      }
    },
  },
  beforeMount() {
    this.getSelfVerifyConfig()
  },
  async created() {
    lgyslide()
    if (this.isStore) {
      return
    }
    await fromVzanHostPath()
    const { skId, jump, zbid } = getParams()
    if (skId && !jump) {
      const href = window.location.href + '&jump=true'
      const url = encodeURIComponent(href)
      const res = await commonAjax.getEncryptUrlInfo(url)
      window.location.href =
        '/live/ThirdWapLogin?backurl=' +
        res.dataObj +
        '&zbid=' +
        zbid +
        '&skId=' +
        skId +
        `${
          this.weComFriend ? '&wcf=' + encodeURIComponent(this.weComFriend) : ''
        }`
    }

    // 注册神策
    HandleSensors()
    /**
     * 但网页被内嵌 App 情况 通过参数 vz_encryid 打通登录
     */
    const EncodeUid = this.$route.query.vz_encryid
    const checkLogin = getCookie(config.COOKIE_KEY) || ''
    if (EncodeUid && !checkLogin) {
      window.$.cookie(config.COOKIE_KEY, EncodeUid)
    }
    // 提现中心独立域名跳vzan带过来的
    const search = new URLSearchParams(location.search)
    const vz_uid = search.get('vz_uid')
    if (vz_uid) {
      window.$.cookie(config.COOKIE_KEY, vz_uid)
    }
    const isNeedReplace = vz_uid && search.get('isNeedReplace')
    if (isNeedReplace) {
      const urlObj = new URL(location.href)
      urlObj.searchParams.delete('vz_uid')
      urlObj.searchParams.delete('isNeedReplace')
      const path = urlObj.toString()
      location.replace(path)
    }
    /**
     * 是否有cookie
     *   是，获取token
     *   否, 是否微信内
     *        是，获取cookie 跳转授权
     *        否，不进行授权，允许匿名访问
     */
    try {
      // 已经注销 进入注销成功页面 不走授权
      // dataMonitor/index 数据监控页无需登录
      console.log('this.$route', this.$route)
      console.log('window.location.pathname', window.location.pathname)
      console.log('this.$route.meta.whiteList,', this.$route.meta.whiteList)
      if (
        window.location.pathname.indexOf('/miniappRegister/index') != -1 ||
        window.location.pathname.indexOf('loginOffSuccess') != -1 ||
        window.location.pathname.indexOf('/vzliveplayer') != -1 ||
        window.location.pathname.indexOf('/dataMonitor/index') != -1 ||
        window.location.pathname.indexOf('/dataMonitor/chart') != -1 ||
        window.location.pathname.indexOf('/agent/aliGuidePage') != -1 ||
        window.location.pathname.indexOf('/clearstore') != -1 ||
        window.location.pathname.indexOf('/agent/openAccount') != -1 ||
        window.location.pathname.indexOf('/superSendWeChat') != -1 ||
        // window.location.pathname.indexOf('/invite/success') != -1 ||
        window.location.pathname.indexOf('/kateTransferPage') != -1 ||
        window.location.pathname.indexOf('/trainInvite') != -1 ||
        this.$route.meta.whiteLis ||
        this.$route.meta.whiteList
      ) {
        this.isRouterAlive = false
        this.isLiveInfoOk = true
        this.isUserInfoOk = true
        this.agentVisible = true
      } else {
        this.handleLogin()
        // await this.authorization()
        // // 企微聊天外部联系人跳转到对应页面
        // let chatOpenUrl = getCookie(`chat_openUrl`)
        // if (chatOpenUrl) {
        //   deleteCookie('chat_openUrl')
        //   setTimeout(() => {
        //     location.href = chatOpenUrl
        //   }, 500)
        // }
      }
    } catch (error) {
      console.log(error)
    }
  },
}
</script>
<style scoped lang="scss">
#app {
  max-width: 476px;
  // transform: translateZ(0); // 先注释了，暂时不清楚加这条的原因，但现在影响到了其他页面了
  margin: 0 auto;
}
.top-nav {
  position: fixed;
  top: 0;
  box-sizing: border-box;
  display: grid;
  grid-template-columns: 1fr 1fr 1fr; /* 三列平分 */
  justify-content: center; /* 水平居中 */
  align-items: center; /* 垂直居中 */
  height: 48px;
  padding: 12px;
  background: #ffffff;
  width: 100%;
  z-index: 2;
  .top-nav-title {
    font-family: PingFang SC, PingFang SC;
    font-weight: 500;
    font-size: 14px;
    color: #202124;
    line-height: 22px;
    text-align: center;
  }
  .top-nav-right {
    text-align: right;
  }
}
.have-nav {
  --have-nav-hegiht: 48px;
}
.no-have-nav {
  --have-nav-hegiht: 0px;
}
.nav-style {
  transform: translateY(var(--have-nav-hegiht));
  height: calc(100vh - var(--have-nav-hegiht));
  filter: unset;
  overflow: auto;
}
.no-have-nav.nav-style {
  transform: unset !important;
}
</style>
